export const normUsername = (u) => String(u || "").trim().replace(/^@+/, "").toLowerCase();

export const parseUsernames = (text) => [...new Set(String(text || "").split(/[\s,;]+/).map(normUsername).filter(Boolean))];

export const fmtNum = (n) => (n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : String(n ?? 0));

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
    return true;
  }
};

export const transferTo = (usernames) => localStorage.setItem("hoom_transfer", usernames.join("\n"));

export const consumeTransfer = () => {
  const v = localStorage.getItem("hoom_transfer");
  if (v) localStorage.removeItem("hoom_transfer");
  return v || "";
};

export const LEAGUE_IMAGES = {
  "A Ligi": "https://p16-webcast.tiktokcdn.com/webcast-va/d516e7bdf072fb6fe52142eb8f84ab6f~tplv-obj.image",
  "B Ligi": "https://p16-webcast.tiktokcdn.com/webcast-va/330b98cbb0be0ec12961ab8873a07f48~tplv-obj.image",
  "C Ligi": "https://p16-webcast.tiktokcdn.com/webcast-va/b5bb0b41c19deb11ce71eea3618b7d8c~tplv-obj.image",
  "D Ligi": "https://p16-webcast.tiktokcdn.com/webcast-va/77e0a18abc1767fdb03c396ed18be07b~tplv-obj.image",
};

const TR_MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.getUTCDate()} ${TR_MONTHS[d.getUTCMonth()]}`;
};
